/**
 * Собирает путь страницы деталей заказа в админке.
 * @param orderId — id заказа
 * @returns путь вида /orders/123
 */
export const buildAdminOrderDetailsPath = (orderId: number): string => {
  return `/orders/${orderId}`
}

/**
 * Читает id заказа из параметра маршрута.
 * @param rawOrderId — useParams().orderId
 * @returns id заказа или null, если значение некорректно
 */
export const parseAdminOrderIdFromParam = (
  rawOrderId: string | undefined
): number | null => {
  if (rawOrderId == null || rawOrderId === '') {
    return null
  }

  const orderId = Number(rawOrderId)
  if (!Number.isInteger(orderId) || orderId <= 0) {
    return null
  }

  return orderId
}
